import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ApiClient from "../../methods/api/apiClient";
import loader from "../../methods/loader";
import methodModel from "../../methods/methods";
import "./style.scss";
import AuthLayout from "../../components/AuthLayout";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { toast } from "react-toastify";
import { BsLock, BsLockFill } from "react-icons/bs";
import { decrypt } from "../../methods/api/Encrypt";

const PASSWORD_RULES = [
  { key: "minLength", label: "At least 8 characters",        test: (v: string) => v.length >= 8 },
  { key: "uppercase", label: "At least 1 uppercase letter",  test: (v: string) => /[A-Z]/.test(v) },
  { key: "lowercase", label: "At least 1 lowercase letter",  test: (v: string) => /[a-z]/.test(v) },
  { key: "number",    label: "At least 1 number",            test: (v: string) => /[0-9]/.test(v) },
  { key: "special",   label: "At least 1 special character", test: (v: string) => /[^A-Za-z0-9]/.test(v) },
];

const validatePassword = (value: string) =>
  PASSWORD_RULES.map((rule) => ({ ...rule, passed: rule.test(value) }));

const isPasswordValid = (value: string) =>
  PASSWORD_RULES.every((rule) => rule.test(value));

const Resetpassword = () => {
  const history = useNavigate();
  const [form, setForm]: any = useState({
    confirmPassword: "",
    newPassword: "",
    verificationCode: "",
    id: "",
  });
  const [submitted, setSubmitted] = useState(false);
  const [eyes, setEyes] = useState({ newPassword: false, confirmPassword: false });

  const passwordRules = validatePassword(form.newPassword);
  const passwordValid  = isPasswordValid(form.newPassword);
  const confirmMatch   = form.confirmPassword === form.newPassword;

  const passedCount = passwordRules.filter((r) => r.passed).length;
  const strengthLabel =
    passedCount <= 1 ? "Weak" : passedCount <= 3 ? "Fair" : passedCount === 4 ? "Good" : "Strong";
  const strengthColor =
    passedCount <= 1 ? "#ef4444" : passedCount <= 3 ? "#f59e0b" : passedCount === 4 ? "#3b82f6" : "#22c55e";

  const formValidation = [
    { key: "confirmPassword", minLength: 8, confirmMatch: ["confirmPassword", "newPassword"] },
    { key: "newPassword", minLength: 8 },
  ];

  useEffect(() => {
    if (localStorage.getItem("token")) {
      history("/dashboard");
    }
    const Data = decrypt(methodModel.getPrams("data"));
    setForm((prev: any) => ({ ...prev, id: Data?.userId, verificationCode: Data?.code }));
  }, []);

  const getError = (key: any) => methodModel.getError(key, form, formValidation);

  const hendleSubmit = (e: any) => {
    e.preventDefault();
    setSubmitted(true);
    if (!passwordValid) return;
    if (!confirmMatch) return;
    let invalid = methodModel.getFormError(formValidation, form);
    if (invalid) return;
    loader(true);
    ApiClient.put("user/reset/password", {
      password: form?.newPassword,
      verificationCode: form?.verificationCode,
      id: form?.id,
    }).then((res) => {
      if (res.success) {
        toast.success(res?.data?.message || "Password changed Successfully");
        history("/login");
      }
      loader(false);
    });
  };

  return (
    <>
      <AuthLayout>

         <div className="auth-page grid lg:grid-cols-2 grid-cols-1 gap-3 max-w-[1100px] w-full rounded-[20px] bg-[#FFFFFF1A] sm:p-7 p-5 mx-auto">
            <div className="w-[400px] lg:block hidden ">
              <img
                src="/img/auth-main.webp"
                className="rounded-[20px] max-h-[520px] "
              />
            </div>
              <div className="w-[360px] max-w-full m-auto">
                    <form onSubmit={hendleSubmit} className="">
                       <div className="relative mb-4">
                  <img
                    src="/img/logo.png"
                    className=" mx-auto max-w-[170px] object-contain"
                    alt="login-image"
                  />
                </div>
                  <div className="mb-8">
                  <h3 className="xl:text-[24px] lg:text-[22px] sm:text-[20px] text-[18px] font-semibold text-[#fff] text-center ">
                 New Password
                  </h3>
                   <p className="text-[12px] sm:text-[14px] font-normal text-[#BCBCBC] text-center mt-2">
                    Please enter a new password for your account
                  </p>
                </div>
              <div className="">
                <div className="mb-1">
                  <div className="relative">
                    <input
                      type={eyes.newPassword ? "text" : "password"}
                      className="w-full text-[#fff] text-sm bg-[#FFFFFF2B] rounded-[10px] outline-none px-3 pr-10 py-3"
                      value={form.newPassword}
                      maxLength={16}
                      onChange={(e) => setForm({ ...form, newPassword: e.target.value })}
                      placeholder="New Password"
                      required
                    />
                    {eyes.newPassword ? (
                      <FiEye
                        className="top-[14px] right-[15px] absolute text-[#bbb] cursor-pointer"
                        onClick={() => setEyes({ ...eyes, newPassword: !eyes.newPassword })}
                      />
                    ) : (
                      <FiEyeOff
                        className="top-[14px] right-[15px] absolute text-[#bbb] cursor-pointer"
                        onClick={() => setEyes({ ...eyes, newPassword: !eyes.newPassword })}
                      />
                    )}
                  </div>

                  {/*
                    KEY FIX: This entire block has a fixed height (118px) and is
                    ALWAYS rendered — it never mounts/unmounts. Content inside
                    fades in via opacity so zero layout shift occurs.
                  */}
                  <div style={{ paddingTop: "8px", overflow: "hidden" }}>

                    {/* Strength bar — fades in, never causes reflow */}
                    <div style={{
                      opacity: 1,
                      transition: "opacity 0.2s",
                    }}>
                      <div style={{ display: "flex", gap: "4px", marginBottom: "4px" }}>
                        {[1, 2, 3, 4, 5].map((n) => (
                          <div
                            key={n}
                            style={{
                              flex: 1,
                              height: "4px",
                              borderRadius: "9999px",
                              background: n <= passedCount ? strengthColor : "#e5e7eb",
                              transition: "background 0.25s",
                            }}
                          />
                        ))}
                      </div>
                      <p style={{
                        fontSize: "11px",
                        fontWeight: 600,
                        color: strengthColor,
                        margin: "0 0 6px 0",
                        transition: "color 0.2s",
                      }}>
                        {strengthLabel}
                      </p>
                    </div>

                    {/* Rule checklist — always rendered, color transitions only */}
                    <ul style={{ margin: 0, padding: 0, listStyle: "none" }}>
                      {passwordRules.map((rule) => (
                        <li
                          key={rule.key}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                            fontSize: "11px",
                            lineHeight: "1.6",
                            color: form.newPassword.length === 0
                              ? "#9ca3af"
                              : rule.passed ? "#22c55e" : "#ef4444",
                            transition: "color 0.2s",
                          }}
                        >
                          <span style={{ fontSize: "10px", width: "10px", flexShrink: 0 }}>
                            {form.newPassword.length === 0 ? "·" : rule.passed ? "✓" : "✗"}
                          </span>
                          {rule.label}
                        </li>
                      ))}
                    </ul>

                  </div>
                  {/* end fixed-height block */}

                </div>
                <div>
                  <div className="relative">
                    <input
                      type={eyes.confirmPassword ? "text" : "password"}
                      className="w-full text-[#fff] text-sm bg-[#FFFFFF2B] rounded-[10px] outline-none px-3 pr-10 py-3"
                      value={form.confirmPassword}
                      maxLength={16}
                      onChange={(e) => setForm({ ...form, confirmPassword: e.target.value })}
                      placeholder="Confirm Password"
                      required
                    />
                    {eyes.confirmPassword ? (
                      <FiEye
                        className="top-[14px] right-[15px] absolute text-[#bbb] cursor-pointer"
                        onClick={() => setEyes({ ...eyes, confirmPassword: !eyes.confirmPassword })}
                      />
                    ) : (
                      <FiEyeOff
                        className="top-[14px] right-[15px] absolute text-[#bbb] cursor-pointer"
                        onClick={() => setEyes({ ...eyes, confirmPassword: !eyes.confirmPassword })}
                      />
                    )}
                  </div>

                  {/* Fixed-height block for confirm feedback — no reflow */}
                  <div style={{ height: "20px", marginTop: "4px" }}>
                    {form.confirmPassword.length > 0 ? (
                      <p style={{
                        fontSize: "12px",
                        color: confirmMatch ? "#22c55e" : "#ef4444",
                        transition: "color 0.2s",
                        margin: 0,
                      }}>
                        {confirmMatch ? "✓ Passwords match" : "✗ Passwords does not match"}
                      </p>
                    ) : submitted ? (
                      <p style={{ fontSize: "12px", color: "#ef4444", margin: 0 }}>
                        Please confirm your password.
                      </p>
                    ) : null}
                  </div>
                </div>
                <div className="mt-6">
                  <button
                    type="submit"
                    className="w-full py-2.5 px-4 text-sm font-semibold tracking-wider rounded-full text-white !bg-[#CC9900] hover:opacity-80 focus:outline-none"
                  >
                    Save
                  </button>
                </div>
              </div>
                      </form>
                      </div>
            </div>

      </AuthLayout>
    </>
  );
};

export default Resetpassword;